<payee-popup [onCancel]="onCancel">
  <ng-template #payeePopupTitleTemplate>
    <h1 class="title">{{ dialogData?.transition_label }}</h1>
  </ng-template>

  <div class="dialog-content">
    <form [formGroup]="form">
      <div class="subtitle">Összeg és pénznem</div>

      <div class="amount-currency-row">
        <payee-form-field width="normal">
          <input
            payee-input
            type="number"
            formControlName="amount"
            min="1"
            placeholder="Összeg"
          />
          @if (form.get("amount")?.invalid && form.get("amount")?.touched) {
            <span payee-error>Kérünk, add meg az összeget (legalább 1).</span>
          }
        </payee-form-field>
        <payee-form-field width="short">
          <payee-dropdown
            formControlName="currency_iso"
            width="short"
            height="taller"
            [options]="currencyOptions"
          ></payee-dropdown>
          @if (form.get("currency_iso")?.invalid && form.get("currency_iso")?.touched) {
            <span payee-error>Kérünk, válaszd ki a pénznemet.</span>
          }
        </payee-form-field>
      </div>

      <payee-workflow-provided-media [transitionWithDialog]="data"></payee-workflow-provided-media>

      <div class="subtitle">Fájlok feltöltése</div>

      <payee-form-field width="wide">
        <payee-dropzone
          width="wide"
          [heading]="dropzoneTitle"
          (dropped)="onDrop($event)"
        ></payee-dropzone>
        @if (form.get("files")?.invalid && form.get("files")?.touched) {
          <span payee-error>Kérünk, tölts fel legalább egy fájlt.</span>
        }
      </payee-form-field>

      <div class="files-list">
        @for (file of files.value; track $index; let fileIndex = $index) {
          <div class="file-item flex vcenter">
            <div class="file-status">
              <payee-icon name="checkmark-darker-green-circle"></payee-icon>
            </div>
            <div class="file-name">{{ file.name }}</div>
            <button
              payee-icon-button
              color="white"
              class="file-delete-button"
              (click)="removeFile(fileIndex)"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          </div>
        }
      </div>
    </form>
  </div>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="wide"
      [disabled]="loading"
      [loading]="loading"
      (click)="onSubmit()"
    >
      Rögzítés
    </button>
  </ng-template>
</payee-popup>
